<div class="LoginFormWrapper">
    <sphere-holiday-snow-effect />
    <sphere-halloween-effect />
    @if (error()) {
        <sphere-alert severity="error" class="LoginError">{{ error() }}</sphere-alert>
    }
    @if (loadingPrincipal()) {
        <sphere-alert severity="info" class="LoginError">Loading user permissions...</sphere-alert>
    }
    <form class="LoginForm mat-elevation-z6">
        <div class="SphereLogoWrapper">
            <img src="/assets/logos/sphere-logo.svg" />
            <h2>SPHERE</h2>
        </div>
        @if (loading() || (hasLastUserCookie() && loadingLoginCheck())) {
            <div class="LoadingAuthn"><mat-spinner mode="indeterminate" [strokeWidth]="2" [diameter]="20" /> Please wait...</div>
        } @else if (loggedIn()) {
            <h3 class="Header">Welcome back</h3>
            <p class="Subheader text-subtle">
                You are logged in as <strong>{{ loggedInUser() }}</strong
                >.
            </p>

            <a [style.margin-bottom.px]="10" matButton="filled" routerLink="/home"> Go to dashboard </a>

            <button class="LoginButton" matButton="outlined" (click)="logout()">Log out</button>
        } @else if (hasLastUserCookie()) {
            <h3 class="Header">Welcome</h3>
            <p class="Subheader text-subtle">
                You recently logged in as <strong>{{ lastUser() }}</strong
                >.
            </p>

            <button [style.margin-bottom.px]="10" matButton="filled" (click)="continueAs(this.lastUser(), this.lastSsoProvider())">
                Continue as {{ lastUser() }}
            </button>

            <button class="LoginButton" matButton="outlined" (click)="continueAsDifferentUser()">Log-in as a different user</button>
        } @else {
            <h3 class="Header">Welcome</h3>
            <p class="Subheader text-subtle">Login to Sphere below</p>
            <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput [(ngModel)]="usernameValue" [ngModelOptions]="{ standalone: true }" />
            </mat-form-field>
            <div class="LoginActions">
                <button
                    [disabled]="loadingAuthenticationProvider() || !validUsernameValue()"
                    [loading]="loadingAuthenticationProvider()"
                    class="LoginButton"
                    matButton="filled"
                    (click)="submitUsername()"
                >
                    Continue
                </button>
                <button matIconButton [matMenuTriggerFor]="moreLoginOptions">
                    <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #moreLoginOptions="matMenu">
                    <button mat-menu-item (click)="useAuth0Login(usernameValue())">Use Enverus authentication</button>
                    <button mat-menu-item (click)="useRedhatSSOLogin(usernameValue() || 'legacy_user')">Use legacy authentication</button>
                </mat-menu>
            </div>
        }
        <p class="Copyright text-subtle-dark">&copy;Copyright {{ currentYear() }} Enverus</p>
    </form>
</div>
